module.exports = __webpack_public_path__ + "media/src/images/dishes-128-d16762cf92682ad85184b2222f55787f.png";